<div class="app-tandem-calendar">
    <div fxLayout="row" class="selectMonth">
        <div fxLayout="column" class="selector">
            <button mat-flat-button (click)="changeMes(-1)" color="primary">Anterior</button>
        </div>
        <div fxLayout="column" class="selector-text align-items-center">
            <span class="texto-mes"> {{ meses[mes] }}, {{ agno }}</span>
        </div>
        <div fxLayout="column" class="selector">
            <button mat-flat-button (click)="changeMes(1)" color="primary">Siguiente</button>
        </div>
    </div>
    <div fxLayout="row">
        <table class="table align-middle mb-0 bg-white">
            <thead>
                <tr class="headerCard">
                    <th class="person"></th>
                    @for (dia of dias; track dia) {
                        <th class="day secundary-text">
                            {{ dia }}
                            <p class="diaSemana">{{ getDiaSemana(dia) }}</p>
                        </th>
                    }
                </tr>
            </thead>
            <tbody>
                @for (person of persons; track person) {
                    <tr>
                        <td class="person-container">
                            <div fxLayout="row" class="fila">
                                <div fxLayout="column" class="imagen">
                                    <img [src]="getImageUser(person.username)" alt="Avatar" />
                                </div>
                                <div fxLayout="column" style="width: 80%; justify-content: center">
                                    <b class="person-name secundary-text">{{ person.name }}</b>
                                </div>
                            </div>
                        </td>
                        @for (m of person.values; track m) {
                            <td>
                                <div
                                    fxLayout="row"
                                    class="burbuja"
                                    style="height: 30px; width: 30px; color: transparent"
                                    [ngClass]="[m == -1 ? 'color-1' : '', m != -1 && m != 0 ? 'color2' : '']"
                                    (click)="goToEvaluation(m.list)"
                                >
                                    -
                                </div>
                            </td>
                        }
                    </tr>
                }
            </tbody>
        </table>
    </div>
</div>
